/** Build `/VolunteerOpportunities?…` with optional detail or event filter query params. */
export function buildVolunteerOpportunitiesPath(params = {}) {
  const { detail, eventId } = params;
  const sp = new URLSearchParams();
  if (detail != null && detail !== "") sp.set("detail", String(detail));
  if (eventId != null && eventId !== "") sp.set("eventId", String(eventId));
  const q = sp.toString();
  return q ? `/VolunteerOpportunities?${q}` : "/VolunteerOpportunities";
}

/** Build `/VolunteerParticipants?…` with optional drill filters (aligned with Volunteer Opportunities). */
export function buildVolunteerParticipantsPath(params = {}) {
  const {
    drillSource,
    opportunityId,
    eventId,
    category,
    status,
    navView,
    navDate,
  } = params;
  const sp = new URLSearchParams();
  if (drillSource) sp.set("drillSource", String(drillSource));
  if (opportunityId != null && opportunityId !== "") sp.set("opportunityId", String(opportunityId));
  if (eventId != null && eventId !== "") sp.set("eventId", String(eventId));
  if (category != null && category !== "") sp.set("category", String(category));
  if (status != null && status !== "") sp.set("status", String(status));
  if (navView) sp.set("navView", String(navView));
  if (navDate) sp.set("navDate", String(navDate));
  const q = sp.toString();
  return q ? `/VolunteerParticipants?${q}` : "/VolunteerParticipants";
}

/** Drill from Volunteer Opportunities list (signed-up count or row context). */
export function buildVolunteerParticipantsDrillFromOpportunities({
  opportunityId,
  eventId,
  categoryFilter,
  statusFilter,
  timeNav,
} = {}) {
  const statusRaw = statusFilter != null ? String(statusFilter).trim() : "";
  return buildVolunteerParticipantsPath({
    drillSource: "volunteer_opportunities",
    opportunityId,
    eventId,
    category: categoryFilter || "",
    status: statusRaw ? statusRaw.toLowerCase() : "",
    navView: timeNav?.view,
    navDate: timeNav?.focusDateYmd,
  });
}
